<template>
	<div>
		<div v-if="data5.length">
			<Tree :data="data5" :render="renderContent"></Tree>
		</div>
		
		<div class="btn_newsort" v-else  @click="Creatfirstroot">新建根类</div>
		<VsModal v-model="modelshow" top="200" width="800px" footerhide>
			<div slot="header">
				<span>新建分类</span>
			</div>
			<div slot="content" style="width: 100%;display: flex;justify-content: center;">
				<Vsform ref="resetform" @fun="ActionFun" :formdata="formdata"></Vsform>
			</div>
		</VsModal>
	</div>
</template>
<script>
	import infoAdd from './TheAddRemark.vue'
	export default {
		props:{
			data:{},
			shehename:{},
			infoNum: Number,
			chr: Boolean,
		},
		computed:{
			mingcheng(){return this.shenhename},
			mdata(){return this.data},
		},
		watch:{
			data(newO){
				this.data5 = newO
			}
		},
		mounted() {
			this.fnGetinfoSort()
		},
		data() {
			return {
				selectNodeKey:'-1', // 选中文件夹效果
				modelfull:false,
				modelshow:false,
				infoRoot:'', // 创建临时类别标记
				formdata:{   // 审核form组件配置
					formwidth:'300',
					action:'fun',//父组件事件
					lable:{
						show:true,width:'80',color:'',fontsize:'',backcolor:'',
					},
					sumitbtn:{
						show:true,desc:'确定',btntype:'success',width:'',height:'',margin:'10px 0px 15px 100px',backcolor:'#00cc99',color:'#fff',fontsize:'14px'
					},
					resetbtn:{
						show:false,desc:'取消',btntype:'success',width:'80',height:'',margin:'10px 10px 0px 0',backcolor:'#00cc99',color:'#fff',fontsize:'14px'
					},
					list:[{
                        lable:'类别名称',
                        key:'Remark',
                        value:'',
                        max:'20',
                        width:'300',
                        require:'true',
                        type:'text',clearable:'clearable',placeholder:'类别名称',
                    }],
				},
				data5:[],
				iconprops: {
					type: 'default',
					size: '18',
				},
			}
		},
		
		methods: {
			fnviewTree(arr){
				let d = arr.map(v=>{
                    if(v.children){
                        return {'name':v.Category,CategoryID:v.CategoryID,Level:v.Level,expand:false,'children':this.fnviewTree(v.children)}
                    }else{
                        return {'name':v.Category,CategoryID:v.CategoryID,Level:v.Level,expand:false}
                    }
				})
				return d
            },
            
			fnGetinfoSort(){
				let params = this.$fun.GetUserConstant()
				this.$Api.ErpGetRemarkSort(params).then((res)=>{
					let ds=res.data.ds;
					this.data5 = this.fnviewTree(ds);
					
				})
			},
			
			Creatfirstroot(){
				let params = {}
				    params.Remark = '摘要档案'
				this.ActionFun(params)
            },
            
            //新建分类时储存临时信息
			fnInfosortChange(data){
				this.modelshow = true
				this.infoRoot = data.CategoryID
			},
            
            //新建商品类别，form组件返回动作，data是返回数据
			ActionFun(data){ 
				let params = Object.assign({},data,this.$fun.GetUserConstant())
				    params.ROOT = this.infoRoot//根目录可为空，子目录必填
				var str = params.Remark.replace(/(^\s*)|(\s*$)/g, '')
                if(str == null || str == ''){
                   	this.$XModal.alert('类别名称不能为空！')
					return
                }
                this.$Api.ErpAddRemarkSort(params).then((res)=>{
				if(res.status == 'SUCCESS'){
                        this.$Message.success({
                            content:'添加成功',
                            druation:3,
                            background:true
                        })
                        this.fnGetinfoSort()//再次请求
                        if(params.ROOT != ''){
                            this.$refs.resetform.Resetdata()
                        }
                        this.$emit('on-reset')
                    }else{
                        this.$Message.error(res.msg)
                    }
                });
            },
            
            //选择类别
			Selected(data){
				this.infoRoot = data.CategoryID//储存商品父类id
				this.selectNodeKey = data.nodeKey
				this.$emit('on-select',data)
            },
            
            //删除类别
			fnInfoSortDelete(data,root,node){
				let params = this.$fun.GetUserConstant()
				    params.InfoID = data.CategoryID
				this.$Api.ErpDelRemarkSort(params).then((res)=>{
					console.log(res);
					if(res.status=='SUCCESS'){
					    this.remove(root,node,data)
						this.fnGetinfoSort()//再次请求
		
						this.$Message.success(res.msg)
					}else{
						this.$Message.error(res.msg)
					}
				})
            },
            
            //提交客户信息
			fnAddinfoAct(){
				this.$emit('on-refresh')
			},
		
			renderContent(h, {root,node,data}) {
                return h('div', { class:{ itembox:true } }, 
                        [
                            h('div', { class:{ itemwrap:true } }, 
                            [
						        h('li',{ 
                                    style:{ height:'100%', color:'#fff', display:'flex', 'align-items':'center' },
                                    on: {
                                        'click':e => {
                                            e.stopPropagation()
                                            this.Selected(data,root,node) 
                                        },
                                        'dblclick':e =>{
                                            e.stopPropagation()
                                            this.show(data,root,node)
                                        }
                                    }
                                },
                                [
                                    h('div',{}, 
                                        [
                                            h('IconSvg',{
                                                props: { name: 'iconicon_folder', size:16 },
                                                style:{ color:'#fb7e36' },
                                                on: {
                                                    click:e => {
                                                        e.stopPropagation()
                                                        this.show(data,root,node) 
                                                    }
                                                }
                                            }),
                                        ]
                                    ),	
                                    h('div',{ style:{ color:this.selectNodeKey==data.nodeKey?'#2d8cf0':'','margin-left':'5px' } },data.name)
                                ]
						),
						h('div',{
							style:{
								color:'#666666',
								right:'2px',
								'margin-left':'5px',
								display:this.selectNodeKey==data.nodeKey?'flex':'none',
								'align-items':'center'
							}
						},
							[	
								h('li',{
									style:{
										display:data.Level== 1?'':'none',
									},
									on: {
										click: e => {
											e.stopPropagation()
											this.fnInfosortChange(data,'新建分类')
										}
									}
								},[
									h('Tooltip',{
										props:{
											content:'新建供摘要分类'
										}
									},[
										h('IconSvg',{
											props: {
												name: 'iconjia',
												size:14,
												color:'#515151'
											},
											
										})
									])
								]),
								h('li',{},[
									h('Tooltip',{
										props:{ content:'添加摘要信息' }
									},[
										h(infoAdd,{
											props:{ category:data },
											on:{
												'on-confirm':data=>{
													this.fnAddinfoAct(data)//提交客户信息
												}
											},
											style:{ display:data.Level== 1?'none':'flex' },
										},[
											h('IconSvg',{
												slot:'title',
												props:{
													name:'iconjia1',
													size:13,
													color:'#fb7e36'
												}
											},[
												
											])
										])
									]),
								]),
								h('li',{
									on: {
										click: e => { 
											e.stopPropagation()
											this.fnInfoSortDelete(data,root,node) }
									    }
                                    },
                                    [
                                        h('Tooltip',{
                                            props:{
                                                content:'删除摘要分类'
                                            }
                                        },
                                        [
                                            h('IconSvg',{
                                                props: {
                                                    name:'iconlajitong',
                                                    size:16,
                                                    color:'#515151',
                                                    left:20,
                                                },
                                                style:{
                                                    display:data.Level== 1?'none':'flex'
                                                },
                                            })
                                        ])
                                     ]),
                                ]
						)
					])
				])
            },
            
			show(data){
				data.expand = !data.expand
			},
			remove(root, node, data) {
				const parentKey = root.find(el => el== node).nodeKey;
				root.splice(parentKey, 1);
            }

            
		}
	}
</script>

<style lang="less">
	.itembox{
		padding-right: 5px;
		height: 26px;
		border-radius: 3px;
		display: inline-block;
		cursor: pointer;
		user-select: none;
	}
	.itemwrap>li>div{
		color: #000;
	}
	.itemwrap{
		width: 100%;
		height: 100%;
		display: flex;
		position: relative;
		align-items: center;
		justify-content: space-between;
	}
	.btn_newsort{
		width: 120px;
		height: 30px;
		margin: 30px 0 0 30px;
		font-size: 16px;
		background: #CCC;
		display:flex;
		justify-content: center;
		align-items: center;
		border-radius: 5px;
		cursor: pointer;
	}
</style>
